{
 "version": 1,
 "familles": [
  {
   "id": "sun",
   "icons": [
    "sun",
    "palmtree"
   ],
   "keywords": [
    "sun",
    "sunny",
    "sunshine",
    "sunlight",
    "solar",
    "summer",
    "soleil",
    "ensoleille",
    "ete",
    "sol",
    "verano",
    "sole",
    "estate",
    "sonne",
    "sommer",
    "sonnig"
   ]
  },
  {
   "id": "moon",
   "icons": [
    "moon"
   ],
   "keywords": [
    "moon",
    "moonlight",
    "lunar",
    "night",
    "midnight",
    "lune",
    "clair",
    "nuit",
    "minuit",
    "luna",
    "noche",
    "medianoche",
    "notte",
    "mond",
    "nacht",
    "mitternacht"
   ]
  },
  {
   "id": "night",
   "icons": [
    "moon",
    "stars"
   ],
   "keywords": [
    "night",
    "nights",
    "nocturnal",
    "dark",
    "darkness",
    "evening",
    "nuit",
    "nuits",
    "soir",
    "obscur",
    "noche",
    "noches",
    "oscuro",
    "notte",
    "notti",
    "buio",
    "nacht",
    "naechte",
    "dunkel",
    "abend"
   ]
  },
  {
   "id": "star",
   "icons": [
    "star",
    "stars"
   ],
   "keywords": [
    "star",
    "stars",
    "starlight",
    "etoile",
    "etoiles",
    "estrella",
    "estrellas",
    "stella",
    "stelle",
    "stern",
    "sterne",
    "astro",
    "astral"
   ]
  },
  {
   "id": "rain",
   "icons": [
    "cloud-rain"
   ],
   "keywords": [
    "rain",
    "rainy",
    "raining",
    "rainfall",
    "shower",
    "pluie",
    "pluvieux",
    "averse",
    "lluvia",
    "lluvioso",
    "pioggia",
    "piovoso",
    "regen",
    "regnerisch",
    "nass"
   ]
  },
  {
   "id": "storm",
   "icons": [
    "cloud-lightning",
    "zap"
   ],
   "keywords": [
    "storm",
    "thunder",
    "thunderstorm",
    "lightning",
    "tempest",
    "orage",
    "tonnerre",
    "foudre",
    "tempete",
    "tormenta",
    "trueno",
    "rayo",
    "temporale",
    "tuono",
    "sturm",
    "gewitter",
    "blitz"
   ]
  },
  {
   "id": "snow",
   "icons": [
    "snowflake",
    "cloud-snow"
   ],
   "keywords": [
    "snow",
    "snowy",
    "winter",
    "frost",
    "ice",
    "frozen",
    "cold",
    "neige",
    "neigeux",
    "hiver",
    "gel",
    "glace",
    "froid",
    "nieve",
    "invierno",
    "hielo",
    "frio",
    "neve",
    "inverno",
    "ghiaccio",
    "schnee",
    "eis",
    "kalt"
   ]
  },
  {
   "id": "wind",
   "icons": [
    "wind"
   ],
   "keywords": [
    "wind",
    "windy",
    "breeze",
    "air",
    "blow",
    "vent",
    "venteux",
    "brise",
    "souffle",
    "viento",
    "brisa",
    "aire",
    "vento",
    "brezza",
    "luft"
   ]
  },
  {
   "id": "cloud",
   "icons": [
    "cloud"
   ],
   "keywords": [
    "cloud",
    "clouds",
    "cloudy",
    "sky",
    "heaven",
    "nuage",
    "nuages",
    "ciel",
    "cielo",
    "nube",
    "nubes",
    "nuvola",
    "nuvole",
    "wolke",
    "wolken",
    "himmel"
   ]
  },
  {
   "id": "fire",
   "icons": [
    "flame"
   ],
   "keywords": [
    "fire",
    "flame",
    "flames",
    "burn",
    "burning",
    "hot",
    "heat",
    "blaze",
    "red",
    "rouge",
    "rojo",
    "rosso",
    "rot",
    "feu",
    "flamme",
    "flammes",
    "brule",
    "chaud",
    "chaleur",
    "fuego",
    "llama",
    "arde",
    "caliente",
    "fuoco",
    "fiamma",
    "brucia",
    "caldo",
    "feuer",
    "brennt",
    "heiss"
   ]
  },
  {
   "id": "water",
   "icons": [
    "droplets",
    "waves"
   ],
   "keywords": [
    "water",
    "rain",
    "drop",
    "drops",
    "liquid",
    "wet",
    "eau",
    "goutte",
    "gouttes",
    "liquide",
    "mouille",
    "agua",
    "gota",
    "liquido",
    "acqua",
    "goccia",
    "wasser",
    "tropfen",
    "fluessig"
   ]
  },
  {
   "id": "sea",
   "icons": [
    "waves"
   ],
   "keywords": [
    "sea",
    "ocean",
    "wave",
    "waves",
    "tide",
    "surf",
    "shore",
    "beach",
    "blue",
    "bleu",
    "azul",
    "blu",
    "blau",
    "mer",
    "vague",
    "vagues",
    "maree",
    "plage",
    "mar",
    "ola",
    "olas",
    "playa",
    "mare",
    "onda",
    "onde",
    "spiaggia",
    "meer",
    "welle",
    "wellen",
    "strand"
   ]
  },
  {
   "id": "mountain",
   "icons": [
    "mountain"
   ],
   "keywords": [
    "mountain",
    "mountains",
    "peak",
    "summit",
    "hill",
    "alps",
    "montagne",
    "montagnes",
    "sommet",
    "colline",
    "montana",
    "cumbre",
    "colina",
    "montagna",
    "cima",
    "berg",
    "berge",
    "gipfel",
    "huegel"
   ]
  },
  {
   "id": "rainbow",
   "icons": [
    "rainbow"
   ],
   "keywords": [
    "rainbow",
    "colours",
    "colors",
    "arc",
    "ciel",
    "arcenciel",
    "arcoiris",
    "colores",
    "arcobaleno",
    "colori",
    "regenbogen",
    "farben"
   ]
  },
  {
   "id": "sunrise",
   "icons": [
    "sunrise"
   ],
   "keywords": [
    "sunrise",
    "dawn",
    "morning",
    "early",
    "aube",
    "aurore",
    "matin",
    "amanecer",
    "manana",
    "alba",
    "mattino",
    "sonnenaufgang",
    "morgen"
   ]
  },
  {
   "id": "sunset",
   "icons": [
    "sunset"
   ],
   "keywords": [
    "sunset",
    "dusk",
    "twilight",
    "evening",
    "coucher",
    "crepuscule",
    "soir",
    "atardecer",
    "ocaso",
    "tarde",
    "tramonto",
    "sera",
    "sonnenuntergang",
    "daemmerung",
    "abend"
   ]
  },
  {
   "id": "tree",
   "icons": [
    "trees",
    "tree-pine"
   ],
   "keywords": [
    "tree",
    "trees",
    "forest",
    "wood",
    "woods",
    "jungle",
    "arbre",
    "arbres",
    "foret",
    "bois",
    "arbol",
    "arboles",
    "bosque",
    "selva",
    "albero",
    "alberi",
    "foresta",
    "bosco",
    "baum",
    "baeume",
    "wald"
   ]
  },
  {
   "id": "leaf",
   "icons": [
    "leaf",
    "sprout"
   ],
   "keywords": [
    "leaf",
    "leaves",
    "green",
    "grow",
    "growth",
    "nature",
    "feuille",
    "feuilles",
    "vert",
    "pousse",
    "hoja",
    "hojas",
    "verde",
    "crecer",
    "foglia",
    "foglie",
    "crescere",
    "blatt",
    "blaetter",
    "gruen",
    "wachsen"
   ]
  },
  {
   "id": "flower",
   "icons": [
    "flower"
   ],
   "keywords": [
    "flower",
    "flowers",
    "rose",
    "roses",
    "bloom",
    "blossom",
    "petal",
    "fleur",
    "fleurs",
    "fleurir",
    "petale",
    "flor",
    "flores",
    "rosa",
    "florecer",
    "fiore",
    "fiori",
    "blume",
    "blumen",
    "bluete"
   ]
  },
  {
   "id": "bird",
   "icons": [
    "bird"
   ],
   "keywords": [
    "bird",
    "birds",
    "fly",
    "flying",
    "wing",
    "wings",
    "feather",
    "oiseau",
    "oiseaux",
    "voler",
    "aile",
    "ailes",
    "plume",
    "pajaro",
    "pajaros",
    "volar",
    "ala",
    "pluma",
    "uccello",
    "uccelli",
    "volare",
    "vogel",
    "voegel",
    "fliegen",
    "fluegel",
    "feder"
   ]
  },
  {
   "id": "fish",
   "icons": [
    "fish"
   ],
   "keywords": [
    "fish",
    "fishes",
    "swim",
    "swimming",
    "poisson",
    "poissons",
    "nager",
    "nage",
    "pez",
    "peces",
    "nadar",
    "pesce",
    "pesci",
    "nuotare",
    "fisch",
    "fische",
    "schwimmen"
   ]
  },
  {
   "id": "animal",
   "icons": [
    "paw-print"
   ],
   "keywords": [
    "animal",
    "animals",
    "wild",
    "beast",
    "lion",
    "tiger",
    "wolf",
    "bear",
    "cat",
    "dog",
    "animaux",
    "sauvage",
    "bete",
    "loup",
    "ours",
    "chat",
    "chien",
    "salvaje",
    "lobo",
    "oso",
    "gato",
    "perro",
    "selvaggio",
    "lupo",
    "orso",
    "gatto",
    "cane",
    "tier",
    "tiere",
    "baer",
    "katze",
    "hund"
   ]
  },
  {
   "id": "bug",
   "icons": [
    "bug"
   ],
   "keywords": [
    "bug",
    "bugs",
    "insect",
    "fly",
    "bee",
    "butterfly",
    "spider",
    "insecte",
    "mouche",
    "abeille",
    "papillon",
    "araignee",
    "insecto",
    "mosca",
    "abeja",
    "mariposa",
    "arana",
    "insetto",
    "ape",
    "farfalla",
    "insekt",
    "fliege",
    "biene",
    "schmetterling"
   ]
  },
  {
   "id": "city",
   "icons": [
    "building-2",
    "building"
   ],
   "keywords": [
    "city",
    "cities",
    "town",
    "urban",
    "downtown",
    "street",
    "streets",
    "ville",
    "villes",
    "urbain",
    "centre",
    "rue",
    "rues",
    "ciudad",
    "ciudades",
    "urbano",
    "calle",
    "calles",
    "citta",
    "strada",
    "strade",
    "stadt",
    "staedte",
    "strasse"
   ]
  },
  {
   "id": "home",
   "icons": [
    "house",
    "home"
   ],
   "keywords": [
    "home",
    "house",
    "homes",
    "household",
    "hotel",
    "motel",
    "roof",
    "door",
    "maison",
    "maisons",
    "foyer",
    "toit",
    "porte",
    "casa",
    "casas",
    "hogar",
    "techo",
    "puerta",
    "focolare",
    "tetto",
    "haus",
    "haeuser",
    "zuhause",
    "dach",
    "tuer"
   ]
  },
  {
   "id": "church",
   "icons": [
    "church"
   ],
   "keywords": [
    "church",
    "cathedral",
    "chapel",
    "temple",
    "holy",
    "sacred",
    "eglise",
    "cathedrale",
    "chapelle",
    "sacre",
    "iglesia",
    "catedral",
    "capilla",
    "sagrado",
    "chiesa",
    "cattedrale",
    "sacro",
    "kirche",
    "dom",
    "kapelle",
    "heilig"
   ]
  },
  {
   "id": "factory",
   "icons": [
    "factory"
   ],
   "keywords": [
    "factory",
    "industry",
    "industrial",
    "machine",
    "plant",
    "usine",
    "industrie",
    "industriel",
    "fabrica",
    "industria",
    "maquina",
    "fabbrica",
    "macchina",
    "fabrik",
    "maschine"
   ]
  },
  {
   "id": "store",
   "icons": [
    "store",
    "shopping-bag"
   ],
   "keywords": [
    "store",
    "shop",
    "shopping",
    "market",
    "buy",
    "sell",
    "magasin",
    "boutique",
    "marche",
    "acheter",
    "vendre",
    "tienda",
    "mercado",
    "comprar",
    "vender",
    "negozio",
    "mercato",
    "comprare",
    "laden",
    "geschaeft",
    "markt",
    "kaufen"
   ]
  },
  {
   "id": "tent",
   "icons": [
    "tent"
   ],
   "keywords": [
    "tent",
    "camp",
    "camping",
    "festival",
    "outdoor",
    "tente",
    "tienda",
    "campamento",
    "acampada",
    "tenda",
    "campeggio",
    "zelt",
    "lager"
   ]
  },
  {
   "id": "car",
   "icons": [
    "car"
   ],
   "keywords": [
    "car",
    "cars",
    "drive",
    "driving",
    "ride",
    "motor",
    "auto",
    "voiture",
    "voitures",
    "conduire",
    "rouler",
    "moteur",
    "coche",
    "carro",
    "conducir",
    "macchina",
    "guidare",
    "motore",
    "wagen",
    "fahren"
   ]
  },
  {
   "id": "road",
   "icons": [
    "route",
    "map"
   ],
   "keywords": [
    "road",
    "roads",
    "highway",
    "street",
    "journey",
    "trip",
    "travel",
    "route",
    "routes",
    "autoroute",
    "voyage",
    "trajet",
    "carretera",
    "autopista",
    "viaje",
    "camino",
    "strada",
    "autostrada",
    "viaggio",
    "strasse",
    "autobahn",
    "reise"
   ]
  },
  {
   "id": "train",
   "icons": [
    "train-front"
   ],
   "keywords": [
    "train",
    "trains",
    "rail",
    "railway",
    "metro",
    "subway",
    "station",
    "chemin",
    "gare",
    "tren",
    "trenes",
    "ferrocarril",
    "estacion",
    "treno",
    "treni",
    "ferrovia",
    "zug",
    "zuege",
    "bahn",
    "bahnhof"
   ]
  },
  {
   "id": "plane",
   "icons": [
    "plane"
   ],
   "keywords": [
    "plane",
    "planes",
    "fly",
    "flight",
    "airport",
    "jet",
    "avion",
    "avions",
    "vol",
    "aeroport",
    "aviao",
    "vuelo",
    "aeropuerto",
    "aereo",
    "volo",
    "aeroporto",
    "flugzeug",
    "flug",
    "flughafen"
   ]
  },
  {
   "id": "bike",
   "icons": [
    "bike"
   ],
   "keywords": [
    "bike",
    "bicycle",
    "cycle",
    "ride",
    "velo",
    "bicyclette",
    "pedaler",
    "bici",
    "bicicleta",
    "bicicletta",
    "fahrrad",
    "rad"
   ]
  },
  {
   "id": "boat",
   "icons": [
    "sailboat",
    "ship"
   ],
   "keywords": [
    "boat",
    "ship",
    "sail",
    "sailing",
    "harbour",
    "port",
    "bateau",
    "navire",
    "voile",
    "barco",
    "nave",
    "vela",
    "puerto",
    "barca",
    "porto",
    "boot",
    "schiff",
    "segel",
    "hafen"
   ]
  },
  {
   "id": "rocket",
   "icons": [
    "rocket"
   ],
   "keywords": [
    "rocket",
    "space",
    "star",
    "launch",
    "moon",
    "universe",
    "fusee",
    "espace",
    "lancement",
    "univers",
    "cohete",
    "espacio",
    "lanzamiento",
    "universo",
    "razzo",
    "spazio",
    "rakete",
    "weltraum"
   ]
  },
  {
   "id": "run",
   "icons": [
    "footprints"
   ],
   "keywords": [
    "run",
    "running",
    "runner",
    "walk",
    "walking",
    "step",
    "steps",
    "fast",
    "courir",
    "course",
    "marcher",
    "pas",
    "vite",
    "correr",
    "corriendo",
    "caminar",
    "paso",
    "rapido",
    "correre",
    "camminare",
    "passo",
    "laufen",
    "rennen",
    "gehen",
    "schritt",
    "schnell"
   ]
  },
  {
   "id": "person",
   "icons": [
    "user"
   ],
   "keywords": [
    "you",
    "me",
    "him",
    "her",
    "girl",
    "boy",
    "man",
    "woman",
    "friend",
    "people",
    "toi",
    "moi",
    "elle",
    "lui",
    "fille",
    "garcon",
    "homme",
    "femme",
    "ami",
    "gens",
    "tu",
    "yo",
    "ella",
    "chica",
    "chico",
    "hombre",
    "mujer",
    "amigo",
    "gente",
    "io",
    "lei",
    "ragazza",
    "uomo",
    "donna",
    "amico",
    "du",
    "ich",
    "sie",
    "er",
    "maedchen",
    "junge",
    "mann",
    "frau",
    "freund",
    "leute"
   ]
  },
  {
   "id": "crowd",
   "icons": [
    "users"
   ],
   "keywords": [
    "crowd",
    "people",
    "everybody",
    "together",
    "us",
    "we",
    "foule",
    "gens",
    "tous",
    "ensemble",
    "nous",
    "multitud",
    "gente",
    "todos",
    "juntos",
    "nosotros",
    "folla",
    "tutti",
    "insieme",
    "noi",
    "menge",
    "leute",
    "alle",
    "zusammen",
    "wir"
   ]
  },
  {
   "id": "eye",
   "icons": [
    "eye"
   ],
   "keywords": [
    "eye",
    "eyes",
    "see",
    "seeing",
    "look",
    "looking",
    "watch",
    "vision",
    "oeil",
    "yeux",
    "voir",
    "regarder",
    "vue",
    "ojo",
    "ojos",
    "ver",
    "mirar",
    "vista",
    "occhio",
    "occhi",
    "vedere",
    "guardare",
    "auge",
    "augen",
    "sehen",
    "schauen",
    "blick"
   ]
  },
  {
   "id": "hand",
   "icons": [
    "hand"
   ],
   "keywords": [
    "hand",
    "hands",
    "touch",
    "hold",
    "give",
    "main",
    "mains",
    "toucher",
    "tenir",
    "donner",
    "mano",
    "manos",
    "tocar",
    "dar",
    "mani",
    "toccare",
    "dare",
    "haende",
    "beruehren",
    "geben"
   ]
  },
  {
   "id": "brain",
   "icons": [
    "brain"
   ],
   "keywords": [
    "brain",
    "mind",
    "think",
    "thinking",
    "head",
    "thought",
    "cerveau",
    "esprit",
    "penser",
    "tete",
    "pensee",
    "cerebro",
    "mente",
    "pensar",
    "cabeza",
    "cervello",
    "pensare",
    "testa",
    "gehirn",
    "geist",
    "denken",
    "kopf"
   ]
  },
  {
   "id": "skull",
   "icons": [
    "skull"
   ],
   "keywords": [
    "skull",
    "death",
    "dead",
    "die",
    "bone",
    "kill",
    "crane",
    "mort",
    "mourir",
    "os",
    "tuer",
    "calavera",
    "muerte",
    "morir",
    "hueso",
    "teschio",
    "morte",
    "morire",
    "osso",
    "schaedel",
    "tod",
    "sterben",
    "knochen"
   ]
  },
  {
   "id": "baby",
   "icons": [
    "baby"
   ],
   "keywords": [
    "baby",
    "child",
    "kid",
    "children",
    "born",
    "birth",
    "bebe",
    "enfant",
    "enfants",
    "ne",
    "naissance",
    "nino",
    "ninos",
    "nacer",
    "bimbo",
    "bambino",
    "nato",
    "kind",
    "kinder",
    "geboren"
   ]
  },
  {
   "id": "love",
   "icons": [
    "heart"
   ],
   "keywords": [
    "love",
    "lover",
    "loving",
    "loved",
    "heart",
    "hearts",
    "kiss",
    "baby",
    "darling",
    "amour",
    "aime",
    "aimes",
    "aimer",
    "coeur",
    "coeurs",
    "bisou",
    "cherie",
    "amor",
    "amo",
    "ama",
    "amar",
    "corazon",
    "beso",
    "carino",
    "amore",
    "amare",
    "cuore",
    "bacio",
    "liebe",
    "lieben",
    "herz",
    "kuss",
    "schatz"
   ]
  },
  {
   "id": "joy",
   "icons": [
    "smile",
    "laugh"
   ],
   "keywords": [
    "happy",
    "happiness",
    "joy",
    "joyful",
    "smile",
    "laugh",
    "fun",
    "heureux",
    "bonheur",
    "joie",
    "sourire",
    "rire",
    "amusant",
    "feliz",
    "felicidad",
    "alegria",
    "sonrisa",
    "reir",
    "felice",
    "gioia",
    "sorriso",
    "ridere",
    "gluecklich",
    "freude",
    "laecheln",
    "lachen"
   ]
  },
  {
   "id": "sad",
   "icons": [
    "frown"
   ],
   "keywords": [
    "sad",
    "sadness",
    "cry",
    "crying",
    "tears",
    "lonely",
    "alone",
    "blue",
    "triste",
    "tristesse",
    "pleurer",
    "larmes",
    "seul",
    "solitude",
    "llorar",
    "lagrimas",
    "solo",
    "piangere",
    "lacrime",
    "traurig",
    "weinen",
    "traenen",
    "allein"
   ]
  },
  {
   "id": "angry",
   "icons": [
    "angry"
   ],
   "keywords": [
    "angry",
    "anger",
    "rage",
    "mad",
    "hate",
    "fury",
    "colere",
    "fache",
    "haine",
    "furie",
    "enfado",
    "ira",
    "odio",
    "furia",
    "rabbia",
    "arrabbiato",
    "wut",
    "zorn",
    "wuetend",
    "hass"
   ]
  },
  {
   "id": "dream",
   "icons": [
    "moon",
    "cloud"
   ],
   "keywords": [
    "dream",
    "dreams",
    "dreaming",
    "sleep",
    "asleep",
    "rest",
    "reve",
    "reves",
    "rever",
    "dormir",
    "sommeil",
    "repos",
    "sueno",
    "sonar",
    "descanso",
    "sogno",
    "sognare",
    "dormire",
    "riposo",
    "traum",
    "traeumen",
    "schlafen",
    "ruhe"
   ]
  },
  {
   "id": "peace",
   "icons": [
    "feather"
   ],
   "keywords": [
    "peace",
    "calm",
    "quiet",
    "still",
    "soft",
    "gentle",
    "paix",
    "calme",
    "tranquille",
    "doux",
    "paz",
    "calma",
    "tranquilo",
    "suave",
    "pace",
    "tranquillo",
    "dolce",
    "frieden",
    "ruhe",
    "sanft"
   ]
  },
  {
   "id": "heaven",
   "icons": [
    "sparkles",
    "flame"
   ],
   "keywords": [
    "angel",
    "angels",
    "devil",
    "demon",
    "hell",
    "heaven",
    "paradise",
    "soul",
    "spirit",
    "ange",
    "anges",
    "diable",
    "enfer",
    "paradis",
    "ame",
    "esprit",
    "diablo",
    "demonio",
    "infierno",
    "paraiso",
    "alma",
    "espiritu",
    "angelo",
    "diavolo",
    "inferno",
    "paradiso",
    "anima",
    "engel",
    "teufel",
    "hoelle",
    "himmel",
    "paradies",
    "seele",
    "geist"
   ]
  },
  {
   "id": "fear",
   "icons": [
    "ghost"
   ],
   "keywords": [
    "fear",
    "afraid",
    "scared",
    "ghost",
    "horror",
    "haunt",
    "peur",
    "effraye",
    "fantome",
    "horreur",
    "hante",
    "miedo",
    "asustado",
    "fantasma",
    "paura",
    "spavento",
    "orrore",
    "angst",
    "furcht",
    "geist"
   ]
  },
  {
   "id": "phone",
   "icons": [
    "phone"
   ],
   "keywords": [
    "phone",
    "call",
    "calling",
    "ring",
    "telephone",
    "dial",
    "appel",
    "appeler",
    "sonner",
    "telefono",
    "llamada",
    "llamar",
    "chiamata",
    "chiamare",
    "telefon",
    "anruf",
    "anrufen"
   ]
  },
  {
   "id": "camera",
   "icons": [
    "camera"
   ],
   "keywords": [
    "photo",
    "photos",
    "picture",
    "camera",
    "film",
    "movie",
    "cinema",
    "shot",
    "image",
    "foto",
    "imagen",
    "pelicula",
    "cine",
    "fotografia",
    "immagine",
    "pellicola",
    "kamera",
    "bild",
    "kino"
   ]
  },
  {
   "id": "book",
   "icons": [
    "book",
    "book-open"
   ],
   "keywords": [
    "book",
    "books",
    "read",
    "reading",
    "story",
    "page",
    "write",
    "livre",
    "livres",
    "lire",
    "histoire",
    "ecrire",
    "libro",
    "libros",
    "leer",
    "historia",
    "pagina",
    "escribir",
    "leggere",
    "storia",
    "buch",
    "buecher",
    "lesen",
    "geschichte",
    "seite"
   ]
  },
  {
   "id": "key",
   "icons": [
    "key"
   ],
   "keywords": [
    "key",
    "keys",
    "lock",
    "unlock",
    "door",
    "secret",
    "cle",
    "cles",
    "serrure",
    "porte",
    "llave",
    "llaves",
    "cerradura",
    "puerta",
    "secreto",
    "chiave",
    "chiavi",
    "serratura",
    "porta",
    "segreto",
    "schluessel",
    "schloss",
    "tuer",
    "geheimnis"
   ]
  },
  {
   "id": "money",
   "icons": [
    "coins",
    "banknote"
   ],
   "keywords": [
    "money",
    "cash",
    "gold",
    "rich",
    "dollar",
    "euro",
    "pay",
    "price",
    "cost",
    "argent",
    "liquide",
    "or",
    "riche",
    "payer",
    "prix",
    "cout",
    "dinero",
    "efectivo",
    "oro",
    "rico",
    "pagar",
    "precio",
    "soldi",
    "contanti",
    "ricco",
    "pagare",
    "prezzo",
    "geld",
    "bar",
    "reich",
    "bezahlen",
    "preis"
   ]
  },
  {
   "id": "gift",
   "icons": [
    "gift"
   ],
   "keywords": [
    "gift",
    "present",
    "birthday",
    "christmas",
    "surprise",
    "cadeau",
    "anniversaire",
    "noel",
    "regalo",
    "cumpleanos",
    "navidad",
    "sorpresa",
    "compleanno",
    "natale",
    "geschenk",
    "geburtstag",
    "weihnachten"
   ]
  },
  {
   "id": "glasses",
   "icons": [
    "glasses"
   ],
   "keywords": [
    "glasses",
    "sunglasses",
    "shades",
    "cool",
    "look",
    "lunettes",
    "soleil",
    "gafas",
    "occhiali",
    "brille",
    "sonnenbrille"
   ]
  },
  {
   "id": "umbrella",
   "icons": [
    "umbrella"
   ],
   "keywords": [
    "umbrella",
    "shelter",
    "cover",
    "rain",
    "parapluie",
    "abri",
    "paraguas",
    "refugio",
    "ombrello",
    "riparo",
    "regenschirm",
    "schutz"
   ]
  },
  {
   "id": "light",
   "icons": [
    "lightbulb",
    "lamp"
   ],
   "keywords": [
    "light",
    "lights",
    "lamp",
    "bulb",
    "bright",
    "shine",
    "glow",
    "neon",
    "lumiere",
    "lumieres",
    "lampe",
    "ampoule",
    "brillant",
    "briller",
    "luz",
    "luces",
    "lampara",
    "bombilla",
    "brillar",
    "luce",
    "luci",
    "lampada",
    "lampadina",
    "brillare",
    "licht",
    "lichter",
    "gluehbirne",
    "leuchten"
   ]
  },
  {
   "id": "time",
   "icons": [
    "clock"
   ],
   "keywords": [
    "time",
    "clock",
    "hour",
    "hours",
    "minute",
    "forever",
    "always",
    "never",
    "late",
    "early",
    "temps",
    "heure",
    "heures",
    "toujours",
    "jamais",
    "tard",
    "tot",
    "tiempo",
    "reloj",
    "hora",
    "horas",
    "siempre",
    "nunca",
    "tarde",
    "tempo",
    "orologio",
    "ora",
    "ore",
    "sempre",
    "mai",
    "tardi",
    "zeit",
    "uhr",
    "stunde",
    "stunden",
    "immer",
    "nie",
    "spaet"
   ]
  },
  {
   "id": "calendar",
   "icons": [
    "calendar"
   ],
   "keywords": [
    "day",
    "days",
    "date",
    "week",
    "month",
    "year",
    "today",
    "tomorrow",
    "yesterday",
    "jour",
    "jours",
    "semaine",
    "mois",
    "annee",
    "aujourdhui",
    "demain",
    "hier",
    "dia",
    "dias",
    "fecha",
    "semana",
    "mes",
    "ano",
    "hoy",
    "manana",
    "ayer",
    "giorno",
    "giorni",
    "data",
    "settimana",
    "mese",
    "anno",
    "oggi",
    "domani",
    "ieri",
    "tag",
    "tage",
    "datum",
    "woche",
    "monat",
    "jahr",
    "heute",
    "morgen",
    "gestern"
   ]
  },
  {
   "id": "hourglass",
   "icons": [
    "hourglass"
   ],
   "keywords": [
    "wait",
    "waiting",
    "patience",
    "slow",
    "countdown",
    "attendre",
    "attente",
    "lent",
    "esperar",
    "espera",
    "paciencia",
    "lento",
    "aspettare",
    "attesa",
    "pazienza",
    "warten",
    "geduld",
    "langsam"
   ]
  },
  {
   "id": "coffee",
   "icons": [
    "coffee"
   ],
   "keywords": [
    "coffee",
    "cafe",
    "morning",
    "cup",
    "drink",
    "tea",
    "matin",
    "tasse",
    "boire",
    "the",
    "manana",
    "taza",
    "beber",
    "caffe",
    "mattina",
    "tazza",
    "bere",
    "te",
    "kaffee",
    "morgen",
    "trinken",
    "tee"
   ]
  },
  {
   "id": "wine",
   "icons": [
    "wine",
    "martini"
   ],
   "keywords": [
    "wine",
    "bar",
    "drink",
    "drunk",
    "cocktail",
    "glass",
    "champagne",
    "vin",
    "boire",
    "ivre",
    "verre",
    "vino",
    "beber",
    "borracho",
    "copa",
    "bere",
    "ubriaco",
    "bicchiere",
    "wein",
    "trinken",
    "betrunken",
    "glas"
   ]
  },
  {
   "id": "beer",
   "icons": [
    "beer"
   ],
   "keywords": [
    "beer",
    "pub",
    "pint",
    "brewery",
    "biere",
    "chope",
    "cerveza",
    "birra",
    "bier",
    "kneipe"
   ]
  },
  {
   "id": "cake",
   "icons": [
    "cake"
   ],
   "keywords": [
    "cake",
    "sweet",
    "sugar",
    "dessert",
    "birthday",
    "gateau",
    "sucre",
    "anniversaire",
    "pastel",
    "dulce",
    "azucar",
    "torta",
    "dolce",
    "zucchero",
    "kuchen",
    "suess",
    "zucker"
   ]
  },
  {
   "id": "fruit",
   "icons": [
    "apple",
    "cherry"
   ],
   "keywords": [
    "apple",
    "fruit",
    "cherry",
    "orange",
    "lemon",
    "sweet",
    "pomme",
    "cerise",
    "citron",
    "manzana",
    "fruta",
    "cereza",
    "limon",
    "mela",
    "frutta",
    "ciliegia",
    "limone",
    "apfel",
    "frucht",
    "kirsche",
    "zitrone"
   ]
  },
  {
   "id": "food",
   "icons": [
    "utensils",
    "pizza"
   ],
   "keywords": [
    "food",
    "eat",
    "eating",
    "hungry",
    "dinner",
    "lunch",
    "meal",
    "manger",
    "faim",
    "diner",
    "dejeuner",
    "repas",
    "comida",
    "comer",
    "hambre",
    "cena",
    "almuerzo",
    "cibo",
    "mangiare",
    "fame",
    "pranzo",
    "essen",
    "hunger",
    "abendessen"
   ]
  },
  {
   "id": "music",
   "icons": [
    "music",
    "music-4"
   ],
   "keywords": [
    "music",
    "song",
    "songs",
    "sing",
    "singing",
    "melody",
    "tune",
    "sound",
    "musique",
    "chanson",
    "chansons",
    "chanter",
    "melodie",
    "son",
    "musica",
    "cancion",
    "canciones",
    "cantar",
    "melodia",
    "sonido",
    "canzone",
    "cantare",
    "suono",
    "musik",
    "lied",
    "lieder",
    "singen",
    "klang"
   ]
  },
  {
   "id": "mic",
   "icons": [
    "mic-vocal",
    "mic"
   ],
   "keywords": [
    "voice",
    "vocal",
    "sing",
    "rap",
    "mic",
    "microphone",
    "shout",
    "scream",
    "voix",
    "chanter",
    "micro",
    "crier",
    "voz",
    "cantar",
    "gritar",
    "voce",
    "cantare",
    "gridare",
    "stimme",
    "singen",
    "schreien",
    "mikrofon"
   ]
  },
  {
   "id": "dance",
   "icons": [
    "sparkles",
    "disc-3"
   ],
   "keywords": [
    "dance",
    "dancing",
    "dancer",
    "party",
    "club",
    "disco",
    "floor",
    "danse",
    "danser",
    "fete",
    "boite",
    "piste",
    "baile",
    "bailar",
    "fiesta",
    "discoteca",
    "pista",
    "ballo",
    "ballare",
    "festa",
    "tanz",
    "tanzen",
    "disko"
   ]
  },
  {
   "id": "headphones",
   "icons": [
    "headphones"
   ],
   "keywords": [
    "headphones",
    "listen",
    "listening",
    "radio",
    "stereo",
    "casque",
    "ecouter",
    "auriculares",
    "escuchar",
    "cuffie",
    "ascoltare",
    "kopfhoerer",
    "hoeren"
   ]
  },
  {
   "id": "guitar",
   "icons": [
    "guitar"
   ],
   "keywords": [
    "guitar",
    "rock",
    "band",
    "strings",
    "riff",
    "guitare",
    "groupe",
    "corde",
    "guitarra",
    "banda",
    "cuerda",
    "chitarra",
    "corda",
    "gitarre",
    "saite"
   ]
  },
  {
   "id": "piano",
   "icons": [
    "piano"
   ],
   "keywords": [
    "piano",
    "keys",
    "classical",
    "concert",
    "note",
    "touche",
    "classique",
    "tecla",
    "clasico",
    "concierto",
    "tasto",
    "classico",
    "concerto",
    "klavier",
    "taste",
    "klassik",
    "konzert"
   ]
  },
  {
   "id": "drum",
   "icons": [
    "drum"
   ],
   "keywords": [
    "drum",
    "drums",
    "beat",
    "beats",
    "rhythm",
    "percussion",
    "tambour",
    "batterie",
    "rythme",
    "tambor",
    "bateria",
    "ritmo",
    "tamburo",
    "batteria",
    "trommel",
    "schlagzeug",
    "rhythmus"
   ]
  },
  {
   "id": "disc",
   "icons": [
    "disc"
   ],
   "keywords": [
    "disc",
    "record",
    "vinyl",
    "album",
    "lp",
    "turntable",
    "dj",
    "disque",
    "vinyle",
    "platine",
    "disco",
    "vinilo",
    "giradischi",
    "vinile",
    "schallplatte",
    "platte"
   ]
  },
  {
   "id": "speaker",
   "icons": [
    "speaker",
    "volume-2"
   ],
   "keywords": [
    "loud",
    "bass",
    "boom",
    "sound",
    "speaker",
    "volume",
    "noise",
    "fort",
    "basse",
    "son",
    "enceinte",
    "bruit",
    "alto",
    "bajo",
    "sonido",
    "altavoz",
    "volumen",
    "ruido",
    "forte",
    "basso",
    "suono",
    "altoparlante",
    "rumore",
    "laut",
    "klang",
    "lautsprecher",
    "laerm"
   ]
  },
  {
   "id": "party",
   "icons": [
    "party-popper"
   ],
   "keywords": [
    "party",
    "celebrate",
    "celebration",
    "festival",
    "carnival",
    "night",
    "out",
    "fete",
    "celebrer",
    "carnaval",
    "sortie",
    "fiesta",
    "celebrar",
    "festa",
    "celebrare",
    "carnevale",
    "feiern",
    "fest",
    "karneval"
   ]
  },
  {
   "id": "king",
   "icons": [
    "crown"
   ],
   "keywords": [
    "king",
    "queen",
    "crown",
    "royal",
    "prince",
    "princess",
    "throne",
    "roi",
    "reine",
    "couronne",
    "princesse",
    "trone",
    "rey",
    "reina",
    "corona",
    "real",
    "principe",
    "re",
    "regina",
    "reale",
    "koenig",
    "koenigin",
    "krone",
    "prinz"
   ]
  },
  {
   "id": "gem",
   "icons": [
    "gem"
   ],
   "keywords": [
    "diamond",
    "gem",
    "jewel",
    "shine",
    "precious",
    "stone",
    "diamant",
    "bijou",
    "precieux",
    "pierre",
    "diamante",
    "joya",
    "precioso",
    "piedra",
    "gioiello",
    "prezioso",
    "pietra",
    "edelstein",
    "kostbar"
   ]
  },
  {
   "id": "magic",
   "icons": [
    "wand",
    "sparkles"
   ],
   "keywords": [
    "magic",
    "magical",
    "spell",
    "wish",
    "dream",
    "wonder",
    "wand",
    "magie",
    "magique",
    "sort",
    "voeu",
    "merveille",
    "baguette",
    "magia",
    "magico",
    "hechizo",
    "deseo",
    "maravilla",
    "incantesimo",
    "desiderio",
    "zauber",
    "magisch",
    "wunsch",
    "wunder"
   ]
  },
  {
   "id": "war",
   "icons": [
    "swords"
   ],
   "keywords": [
    "war",
    "fight",
    "fighting",
    "battle",
    "enemy",
    "soldier",
    "army",
    "guerre",
    "combat",
    "bataille",
    "ennemi",
    "soldat",
    "armee",
    "guerra",
    "pelea",
    "batalla",
    "enemigo",
    "soldado",
    "ejercito",
    "lotta",
    "battaglia",
    "nemico",
    "soldato",
    "krieg",
    "kampf",
    "schlacht",
    "feind"
   ]
  },
  {
   "id": "shield",
   "icons": [
    "shield"
   ],
   "keywords": [
    "shield",
    "protect",
    "protection",
    "safe",
    "guard",
    "defend",
    "bouclier",
    "proteger",
    "garder",
    "defendre",
    "escudo",
    "proteccion",
    "guardar",
    "scudo",
    "proteggere",
    "protezione",
    "schild",
    "schutz",
    "schuetzen"
   ]
  },
  {
   "id": "flag",
   "icons": [
    "flag"
   ],
   "keywords": [
    "flag",
    "country",
    "nation",
    "home",
    "land",
    "drapeau",
    "pays",
    "terre",
    "bandera",
    "pais",
    "nacion",
    "tierra",
    "bandiera",
    "paese",
    "nazione",
    "terra",
    "flagge"
   ]
  },
  {
   "id": "circle",
   "icons": [
    "circle"
   ],
   "keywords": [
    "circle",
    "round",
    "loop",
    "cycle",
    "again",
    "cercle",
    "rond",
    "boucle",
    "encore",
    "circulo",
    "redondo",
    "bucle",
    "ciclo",
    "otra",
    "cerchio",
    "rotondo",
    "ancora",
    "kreis",
    "rund",
    "schleife",
    "zyklus",
    "wieder"
   ]
  },
  {
   "id": "square",
   "icons": [
    "square"
   ],
   "keywords": [
    "square",
    "block",
    "box",
    "cube",
    "carre",
    "bloc",
    "boite",
    "cuadrado",
    "bloque",
    "caja",
    "cubo",
    "quadrato",
    "blocco",
    "scatola",
    "quadrat",
    "kasten",
    "wuerfel"
   ]
  },
  {
   "id": "triangle",
   "icons": [
    "triangle"
   ],
   "keywords": [
    "triangle",
    "peak",
    "up",
    "point",
    "pyramid",
    "pointe",
    "haut",
    "pyramide",
    "triangulo",
    "punta",
    "arriba",
    "piramide",
    "triangolo",
    "dreieck",
    "spitze"
   ]
  },
  {
   "id": "zap",
   "icons": [
    "zap"
   ],
   "keywords": [
    "electric",
    "energy",
    "power",
    "shock",
    "spark",
    "bolt",
    "flash",
    "electrique",
    "energie",
    "puissance",
    "choc",
    "eclair",
    "electrico",
    "energia",
    "poder",
    "chispa",
    "rayo",
    "elettrico",
    "potenza",
    "scintilla",
    "elektrisch",
    "kraft",
    "funke",
    "blitz"
   ]
  },
  {
   "id": "arrow",
   "icons": [
    "arrow-right",
    "arrow-up"
   ],
   "keywords": [
    "go",
    "going",
    "forward",
    "next",
    "up",
    "rise",
    "away",
    "aller",
    "avance",
    "suivant",
    "haut",
    "monter",
    "partir",
    "ir",
    "adelante",
    "siguiente",
    "arriba",
    "subir",
    "andare",
    "avanti",
    "prossimo",
    "su",
    "salire",
    "gehen",
    "vorwaerts",
    "naechste",
    "hoch",
    "steigen"
   ]
  },
  {
   "id": "infinity",
   "icons": [
    "infinity"
   ],
   "keywords": [
    "forever",
    "infinite",
    "endless",
    "eternal",
    "always",
    "toujours",
    "infini",
    "eternel",
    "sans",
    "fin",
    "siempre",
    "infinito",
    "eterno",
    "sempre",
    "immer",
    "unendlich",
    "ewig"
   ]
  },
  {
   "id": "grid",
   "icons": [
    "grid-3x3",
    "layers"
   ],
   "keywords": [
    "grid",
    "pattern",
    "layers",
    "system",
    "order",
    "matrix",
    "grille",
    "motif",
    "couches",
    "systeme",
    "ordre",
    "rejilla",
    "patron",
    "capas",
    "sistema",
    "orden",
    "griglia",
    "motivo",
    "strati",
    "ordine",
    "gitter",
    "muster",
    "schichten",
    "ordnung"
   ]
  },
  {
   "id": "repeat",
   "icons": [
    "repeat",
    "shuffle"
   ],
   "keywords": [
    "repeat",
    "again",
    "loop",
    "over",
    "random",
    "shuffle",
    "repeter",
    "encore",
    "boucle",
    "hasard",
    "aleatoire",
    "repetir",
    "otra",
    "bucle",
    "azar",
    "ripetere",
    "ancora",
    "caso",
    "casuale",
    "wiederholen",
    "nochmal",
    "zufall"
   ]
  },
  {
   "id": "target",
   "icons": [
    "target"
   ],
   "keywords": [
    "target",
    "aim",
    "goal",
    "focus",
    "center",
    "cible",
    "viser",
    "but",
    "centre",
    "objetivo",
    "apuntar",
    "meta",
    "centro",
    "bersaglio",
    "mirare",
    "obiettivo",
    "ziel",
    "zielen",
    "mitte"
   ]
  },
  {
   "id": "palette",
   "icons": [
    "palette",
    "brush"
   ],
   "keywords": [
    "colour",
    "color",
    "paint",
    "art",
    "draw",
    "artist",
    "couleur",
    "peinture",
    "dessin",
    "artiste",
    "pintura",
    "arte",
    "dibujo",
    "artista",
    "colore",
    "pittura",
    "disegno",
    "farbe",
    "malerei",
    "kunst",
    "zeichnen"
   ]
  },
  {
   "id": "puzzle",
   "icons": [
    "puzzle"
   ],
   "keywords": [
    "puzzle",
    "game",
    "play",
    "piece",
    "mystery",
    "jeu",
    "jouer",
    "mystere",
    "juego",
    "jugar",
    "pieza",
    "misterio",
    "gioco",
    "giocare",
    "pezzo",
    "mistero",
    "spiel",
    "spielen",
    "stueck",
    "raetsel"
   ]
  },
  {
   "id": "orbit",
   "icons": [
    "orbit",
    "atom"
   ],
   "keywords": [
    "space",
    "universe",
    "atom",
    "planet",
    "orbit",
    "science",
    "cosmos",
    "espace",
    "univers",
    "atome",
    "planete",
    "espacio",
    "universo",
    "atomo",
    "planeta",
    "spazio",
    "pianeta",
    "weltraum",
    "universum"
   ]
  },
  {
   "id": "telescope",
   "icons": [
    "telescope"
   ],
   "keywords": [
    "look",
    "far",
    "distance",
    "search",
    "find",
    "horizon",
    "chercher",
    "trouver",
    "loin",
    "buscar",
    "encontrar",
    "lejos",
    "horizonte",
    "cercare",
    "trovare",
    "lontano",
    "orizzonte",
    "suchen",
    "finden",
    "fern",
    "horizont"
   ]
  },
  {
   "id": "bed",
   "icons": [
    "bed"
   ],
   "keywords": [
    "bed",
    "sleep",
    "night",
    "room",
    "hotel",
    "lit",
    "dormir",
    "nuit",
    "chambre",
    "cama",
    "noche",
    "habitacion",
    "letto",
    "dormire",
    "notte",
    "camera",
    "bett",
    "schlafen",
    "zimmer"
   ]
  },
  {
   "id": "shirt",
   "icons": [
    "shirt"
   ],
   "keywords": [
    "clothes",
    "dress",
    "wear",
    "style",
    "fashion",
    "vetement",
    "robe",
    "porter",
    "mode",
    "ropa",
    "vestido",
    "llevar",
    "moda",
    "vestito",
    "indossare",
    "kleidung",
    "kleid",
    "tragen"
   ]
  },
  {
   "id": "dice",
   "icons": [
    "dice-5"
   ],
   "keywords": [
    "luck",
    "lucky",
    "chance",
    "game",
    "bet",
    "dice",
    "chanceux",
    "jeu",
    "pari",
    "des",
    "suerte",
    "azar",
    "juego",
    "apuesta",
    "dado",
    "fortuna",
    "caso",
    "gioco",
    "scommessa",
    "glueck",
    "zufall",
    "spiel",
    "wette",
    "wuerfel"
   ]
  },
  {
   "id": "magnet",
   "icons": [
    "magnet"
   ],
   "keywords": [
    "attract",
    "pull",
    "magnet",
    "force",
    "attirer",
    "aimant",
    "atraer",
    "iman",
    "fuerza",
    "attrarre",
    "magnete",
    "forza",
    "anziehen",
    "kraft"
   ]
  },
  {
   "id": "scroll",
   "icons": [
    "scroll"
   ],
   "keywords": [
    "story",
    "tale",
    "poem",
    "word",
    "words",
    "letter",
    "histoire",
    "conte",
    "poeme",
    "mot",
    "mots",
    "lettre",
    "historia",
    "cuento",
    "poema",
    "palabra",
    "letra",
    "storia",
    "racconto",
    "poesia",
    "parola",
    "lettera",
    "geschichte",
    "maerchen",
    "gedicht",
    "wort",
    "brief"
   ]
  },
  {
   "id": "scissors",
   "icons": [
    "scissors"
   ],
   "keywords": [
    "cut",
    "break",
    "end",
    "split",
    "couper",
    "casser",
    "fin",
    "romper",
    "tagliare",
    "rompere",
    "fine",
    "schneiden",
    "brechen",
    "ende"
   ]
  }
 ],
 "regleSeule": [
  "minus",
  "activity",
  "columns"
 ],
 "icones": [
  "activity",
  "angry",
  "apple",
  "arrow-right",
  "arrow-up",
  "atom",
  "baby",
  "banknote",
  "bed",
  "beer",
  "bike",
  "bird",
  "book",
  "book-open",
  "brain",
  "brush",
  "bug",
  "building",
  "building-2",
  "cake",
  "calendar",
  "camera",
  "car",
  "cherry",
  "church",
  "circle",
  "clock",
  "cloud",
  "cloud-lightning",
  "cloud-rain",
  "cloud-snow",
  "coffee",
  "coins",
  "columns",
  "crown",
  "dice-5",
  "disc",
  "disc-3",
  "droplets",
  "drum",
  "eye",
  "factory",
  "feather",
  "fish",
  "flag",
  "flame",
  "flower",
  "footprints",
  "frown",
  "gem",
  "ghost",
  "gift",
  "glasses",
  "grid-3x3",
  "guitar",
  "hand",
  "headphones",
  "heart",
  "home",
  "hourglass",
  "house",
  "infinity",
  "key",
  "lamp",
  "laugh",
  "layers",
  "leaf",
  "lightbulb",
  "magnet",
  "map",
  "martini",
  "mic",
  "mic-vocal",
  "minus",
  "moon",
  "mountain",
  "music",
  "music-4",
  "orbit",
  "palette",
  "palmtree",
  "party-popper",
  "paw-print",
  "phone",
  "piano",
  "pizza",
  "plane",
  "puzzle",
  "rainbow",
  "repeat",
  "rocket",
  "route",
  "sailboat",
  "scissors",
  "scroll",
  "shield",
  "ship",
  "shirt",
  "shopping-bag",
  "shuffle",
  "skull",
  "smile",
  "snowflake",
  "sparkles",
  "speaker",
  "sprout",
  "square",
  "star",
  "stars",
  "store",
  "sun",
  "sunrise",
  "sunset",
  "swords",
  "target",
  "telescope",
  "tent",
  "train-front",
  "tree-pine",
  "trees",
  "triangle",
  "umbrella",
  "user",
  "users",
  "utensils",
  "volume-2",
  "wand",
  "waves",
  "wind",
  "wine",
  "zap"
 ]
}
